<template>
  <b-container class="bv-example-row" style="color: rgb(37, 91, 48)">
        <p class="title" style="color: rgb(37, 91, 48)">Beteseb <span style=" color: rgba(240, 206, 13, 0.937); margin-left: 10px;">Ekub</span></p>
        <b-card >
          <b-row no-gutters style="padding: 15px; display: flex; justify-content: center; align-items: center;">
              <b-card-img :src="require('../../assets/Tsehay_logo_big.png')" alt="Image" class="rounded-0" style="width: 150px;height: 150px;"> 
              </b-card-img>
          </b-row>
          <b-row no-gutters>
          <b-col md="12" style="display: grid; justify-content: center; align-items: center;">
              <b-card-body title=""> 
                  <b-form class="text-left" @submit="onSubmit">
                      <label for="text-username">User Name</label>
                      <b-form-input type="text" id="text-username"  class="mb-3 mr-sm-2" v-model="user.username" required></b-form-input>
                      <label for="text-pwd">Password</label>
                      <b-input-group class="mb-3 mr-sm-2">
                          <b-form-input id="text-pwd" :type="type" v-model="user.password" required></b-form-input>
                          <b-input-group-append>
                          <b-button variant="outline" class="unhide" @click="showPassword()"><b-icon class="text-center" :icon="icon"></b-icon></b-button>
                          </b-input-group-append>
                      </b-input-group>
                      <b-button type="submit" variant="primary" style="color: rgb(37, 91, 48);font-weight: 600; " :disabled="searchFlag">Login</b-button>
                      <!-- <b-button to="/KYC/registerUser" variant="outline-primary" class="outline-primary">Register</b-button> -->
                      <b-button class="mt-2" variant="link" @click="resetPassword()" style="text-align:center; color: rgb(37, 91, 48);font-weight: 600; border: none !important;">Forgot Password?</b-button>
                  </b-form>
              </b-card-body>
          </b-col>
          </b-row>
        </b-card>
    </b-container>
</template>

<script>
export default {
    data(){
        return{
            user:{
                username: '',
                password: ''
            },
            type: 'password',
            icon: 'eye',
            searchFlag: false
        }
    },
    methods:{
        onSubmit(event) {
    event.preventDefault();
    
    // Validate if username and password are provided
    if (!this.user.username || !this.user.password) {
        this.$notifications.notify({
            message: "Please enter both username and password.",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning'
        });
        return;
    }

    // Set the searchFlag to prevent multiple submits
    this.searchFlag = true;

    this.$store.dispatch('RetriveToken', { username: this.user.username, password: this.user.password })
        .then(response => {
            // Check if response is valid and contains data
            if (!response || !response.data) {
                throw new Error("Invalid server response.");
            }
            // console.log("User", response.data);
            // Handle the "Please change your password" case
            if (response.data.message === 'Please change your password.') {
                this.$router.push({ name: 'ChangePassword' });
                return; // Stop further execution
            } 
            // Check if the token or necessary user data is in the response
            const token = response.data.token;
            if (!token) {
                throw new Error("No token found in response.");
            }
            // Store the token (assuming you store it in localStorage or sessionStorage)
            sessionStorage.setItem('auth_token', token);

            const userRole = sessionStorage.getItem("user_role");
            if (!userRole) {
                throw new Error("User role not found in session storage.");
            }

            const roleRedirectMap = {
                "ADMIN": "Dashboard",
                "MANAGER": "Dashboard",
                "FINANCE": "Dashboard",
                "USER": "Dashboard",
                "SUPER_ADMIN": "DashboardSuper",
                "SUPER_MANAGER": "DashboardSuper",
                "SUPER_FINANCE": "DashboardSuper",
                "SUPER_USER": "DashboardSuper",
                "SYSTEM_ADMIN": "UserSystem",
                "SYSTEM_MANAGER": "UserSystem",
            };

            const targetRoute = roleRedirectMap[userRole];
            if (targetRoute) {
                this.$router.push({ name: targetRoute });
            } else {
                throw new Error("Invalid user role.");
            }
        })
        .catch(error => {
            // Handle errors
            const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message || "An unexpected error occurred.";
            this.$notifications.notify({
                message: errorMessage,
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
            });
        })
        .finally(() => {
            // Reset the searchFlag when the operation is complete
            this.searchFlag = false;
        });
},
        showPassword(){
            if(this.type === 'password'){
                this.type = 'text';
                this.icon = 'eye-slash'
            }
            else{
                this.type = 'password';
                this.icon = 'eye';
            }
            return;
        },
        resetPassword() {
            this.$router.push({name: 'ForgotPassword'});
        }
    },
}
 
</script>

<style scoped>
.bv-example-row{
    margin-top: 6%;
}
.form-control{
    padding: 10px;
}
.btn-primary{
    background: rgba(240, 206, 13, 0.937);
    border-color: rgba(240, 206, 13, 0.937);
    width: 100%;
}
.outline-primary{
    border-color: rgba(240, 206, 13, 0.937);
    color: rgba(240, 206, 13, 0.937);
    margin-left: 10px;
    background: transparent;
}
.outline-primary:hover {
    background: rgba(240, 206, 13, 0.937);
    color: #FFF;
}
.card{
    width: 100%;
    height: 100%;
}
.card-body{
    padding-top: 0;
    padding-bottom: 0;
}
.row > *{
    padding: 0 0;
}
.row {
    --bs-gutter-x: 2rem;
}
.bv-example-row{
     display: grid;
    justify-content: center;
    align-items: center;
}
.title{
    display: flex;
    justify-content: center;
    font-size: 30px;
    font-family: monospace;
    font-weight: bold;
}
.unhide{
    border: 1px solid #ced4da;
    color: rgb(37, 91, 48); 
    height: 100%;
}
@media (max-width: 768px) {
    .unhide{
        height: 80%;
    }
}
</style>